import * as Icons from 'lucide-react';

/**
 * Dynamic Icon Component
 * Renders a Lucide icon by name string
 * 
 * Usage:
 * <Icon name="CheckCircle" size={16} color="#10b981" />
 */
export function Icon({ name, size = 16, color = "currentColor", className = "", ...props }) {
  const IconComponent = Icons[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in lucide-react`);
    return null;
  }
  
  return (
    <IconComponent 
      size={size} 
      color={color} 
      className={className}
      {...props}
    />
  );
}

/**
 * Get icon name from status/role metadata
 * Returns the icon component directly
 */
export function getIconFromMeta(meta, size = 16) {
  if (!meta?.icon) return null;
  const IconComponent = Icons[meta.icon];
  if (!IconComponent) return null;
  
  return <IconComponent size={size} color={meta.color} />;
}
